import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { } from 'components'
import { Col, CardImg, CardBody, CardTitle, Button, Card, CardFooter } from 'reactstrap'
import { } from "phosphor-react"

class SearchItem extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            // eslint-disable-next-line no-undef
            imageUrl: process.env.REACT_APP_IMAGEURL,
        }
        this.readMore = this.readMore.bind(this)
    }

    readMore(event) {
        event.preventDefault()
        let link
        switch (this.props.href) {
            case 'Course':
                link = `/item/${this.props.id}`
                break
            default:
                link = `/${this.props.href.toLowerCase()}/${this.props.id}`
                break
        }
        this.props.props.history.push(link)
    }

    render() {
        const { t } = this.props
        return (
            <Col xl={4} lg={6} md={12} className="d-flex align-items-stretch">
                <Card className="d-flex flex-column">
                    <CardImg src={this.props.image ? `${this.state.imageUrl}/${this.props.image}` : "data:,"} alt="" onClick={this.readMore} />
                    <CardBody className="project-body">
                        <CardTitle className="project md-font-size">{this.props.title}</CardTitle>
                        <div className="card-desc project md-font-size" dangerouslySetInnerHTML={{ __html: this.props.desc }}></div>
                    </CardBody>
                    <CardFooter className="mt-auto">
                        <div className="catalog-card-bottom project mt-0">
                            <Button type="button" className="btn profile-avatar-btn primary p-10-20px sm-font-size" onClick={this.readMore}>{t('search-read-more')}</Button>
                        </div>
                    </CardFooter>
                </Card>
            </Col>
        )
    }
}

SearchItem.propTypes = {
    t: PropTypes.func,
    title: PropTypes.string,
    href: PropTypes.string,
    id: PropTypes.number,
    image: PropTypes.string,
    desc: PropTypes.string,
    props: PropTypes.object,
}

export default withTranslation()(SearchItem)


// WEBPACK FOOTER //
// ./src/components/Search/SearchItem.jsx